$(document).ready(function() {
  $(window).scroll(function() {
    if ($(window).scrollTop() > 100) {
      $(".fixed-icon").show();
    } else {
      $(".fixed-icon").hide();
    }
  });
});
